/* XNote Write PDP review feed (#all-reviews). Ported from v2 ia-customer-reviews.js + ia-review-photos.js, namespaced
   xp-rfeed. Review text is never changed; only its collapsed presentation. Without this script the first six show. */
(() => {
  'use strict';
  const COLLAPSED_DESKTOP = 4, COLLAPSED_PHONE = 3, PAGE_SIZE = 6;
  const phone = matchMedia('(max-width:767px)');
  const fmt = new Intl.DateTimeFormat('en-US', { month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC' });

  /* ---- Photo lightbox (one dialog for the page) ---- */
  let dialog, lastTrigger;
  function setupDialog() {
    dialog = document.createElement('dialog');
    dialog.className = 'xp-rfeed-dialog';
    dialog.setAttribute('aria-label', 'Customer photo');
    dialog.innerHTML = '<header><span></span><button type="button" aria-label="Close customer photo">×</button></header><figure><img alt=""></figure><p hidden>Photo could not load. Please try again.</p>';
    document.body.append(dialog);
    dialog.querySelector('button').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', e => { if (e.target === dialog) dialog.close(); });
    dialog.addEventListener('close', () => lastTrigger && lastTrigger.focus());
    dialog.querySelector('img').addEventListener('error', () => { dialog.querySelector('p').hidden = false; });
  }
  document.addEventListener('click', e => {
    const trigger = e.target.closest('[data-xp-rfeed-photo]');
    if (!trigger) return;
    if (!dialog) setupDialog();
    lastTrigger = trigger;
    const who = trigger.dataset.xpRfeedAuthor || 'an XNote customer';
    const img = dialog.querySelector('img');
    dialog.querySelector('header span').textContent = 'Photo from ' + who;
    img.alt = 'XNote photo shared by ' + who;
    dialog.querySelector('p').hidden = true;
    img.src = trigger.dataset.xpRfeedPhoto;
    dialog.showModal();
  });

  const SET_NAMES = ['XNote Full Set', 'XNote Smart Writing Set'];
  const CHECK = '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="m5 12.5 4.5 4.5L19 7.5"/></svg>';

  document.querySelectorAll('[data-xp-rfeed]').forEach(root => {
    const q = s => root.querySelector(s);
    const section = root.closest('section') || document;
    const list = q('[data-xp-rfeed-list]');
    const entries = [...list.children];
    const search = q('[data-xp-rfeed-search]'), sort = q('[data-xp-rfeed-sort]'), photos = q('[data-xp-rfeed-photos]');
    const prev = q('[data-xp-rfeed-prev]'), next = q('[data-xp-rfeed-next]'), clear = q('[data-xp-rfeed-clear]');
    const more = q('[data-xp-rfeed-more]'), pager = q('[data-xp-rfeed-pager]'), controls = q('[data-xp-rfeed-controls]');
    const count = q('[data-xp-rfeed-count]'), empty = q('[data-xp-rfeed-empty]'), pageLabel = q('[data-xp-rfeed-page]');
    const barsBox = section.querySelector('[data-xp-rfeed-bars]');
    const bars = barsBox ? [...barsBox.querySelectorAll('[data-xp-rfeed-bar]')] : [];
    let page = 1, expanded = false, rating = 'all', photosOnly = false;

    /* Card layout: stars + date on top, an initial avatar and a verified tick by the name, a chip for reviews of
       another XNote product. Text is never changed. */
    entries.forEach(entry => {
      const copy = entry.querySelector('.xp-rfeed__copy'), person = entry.querySelector('.xp-rfeed__person');
      const stars = copy.querySelector('.xp-rfeed__stars'), time = person.querySelector('time');
      const top = document.createElement('div'); top.className = 'xp-rfeed__top';
      if (stars) top.append(stars);
      if (time) { time.textContent = fmt.format(new Date(time.dateTime + 'T00:00:00Z')); top.append(time); }
      copy.prepend(top);
      const name = person.querySelector('strong'), badge = person.querySelector('span');
      const av = document.createElement('span'); av.className = 'xp-rfeed__av'; av.setAttribute('aria-hidden', 'true');
      av.textContent = (name ? name.textContent.trim().charAt(0) : '·').toUpperCase();
      person.prepend(av);
      const who = document.createElement('span'); who.className = 'xp-rfeed__who';
      if (name) who.append(name);
      if (badge) { badge.className = 'xp-rfeed__ok'; badge.insertAdjacentHTML('afterbegin', CHECK); who.append(badge); }
      person.append(who);
      const product = entry.dataset.reviewProduct;
      if (product && !SET_NAMES.includes(product)) {
        const chip = document.createElement('span'); chip.className = 'xp-rfeed__prod'; chip.textContent = product;
        person.append(chip);
      }
    });

    /* Star bars: share of each rating in this list; a click filters, a second click clears. */
    if (bars.length) {
      bars.forEach(b => {
        const n = b.dataset.xpRfeedBar, c = entries.filter(r => r.dataset.rating === n).length;
        const pct = entries.length ? Math.round((c / entries.length) * 100) : 0;
        b.querySelector('.xp-rv__track i').style.width = pct + '%';
        b.querySelector('.xp-rv__pct').textContent = pct + '%';
        b.setAttribute('aria-label', n + ' stars, ' + pct + '% of reviews. Show only these');
        b.disabled = c === 0;
        b.addEventListener('click', () => { rating = rating === n ? 'all' : n; reset(); });
      });
      barsBox.hidden = false;
    }

    /* Long reviews collapse to a few lines with "Read full review" (v2 behaviour). */
    const disclosures = entries.map((entry, i) => {
      const copy = entry.querySelector('.xp-rfeed__copy'), title = copy.querySelector('h3'), body = copy.querySelector('p');
      const norm = t => t.replace(/[\s.!…]+$/g, '').trim().toLocaleLowerCase();
      if (norm(body.textContent).startsWith(norm(title.textContent)) || /^[\s.…]*$/.test(title.textContent)) entry.classList.add('is-untitled');
      title.id = 'xp-rfeed-title-' + i; body.id = 'xp-rfeed-body-' + i;
      const btn = document.createElement('button');
      btn.type = 'button'; btn.className = 'xp-rfeed__more'; btn.textContent = 'Read more'; btn.hidden = true;
      btn.setAttribute('aria-expanded', 'false'); btn.setAttribute('aria-controls', body.id);
      body.after(btn);
      entry.classList.add('is-collapsible');
      btn.addEventListener('click', () => {
        const open = entry.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', String(open));
        btn.textContent = open ? 'Show less' : 'Read more';
      });
      return { entry, body, btn };
    });
    function refreshDisclosures() {
      disclosures.forEach(({ entry, body, btn }) => {
        if (!entry.getClientRects().length || entry.classList.contains('is-open')) return;
        btn.hidden = !(body.scrollHeight > body.clientHeight + 1);
      });
    }

    function update() {
      const query = search.value.trim().toLocaleLowerCase();
      const filtered = entries.filter(r =>
        (rating === 'all' || r.dataset.rating === rating) &&
        (!photosOnly || r.dataset.hasPhoto === 'true') &&
        (!query || r.textContent.toLocaleLowerCase().includes(query))
      ).sort((a, b) => {
        if (sort.value === 'featured') { const o = Number(a.dataset.featuredRank || 999) - Number(b.dataset.featuredRank || 999); if (o) return o; }
        if (sort.value === 'photos') { const o = Number(b.dataset.hasPhoto === 'true') - Number(a.dataset.hasPhoto === 'true'); if (o) return o; }
        if (sort.value === 'lowest') { const o = Number(a.dataset.rating) - Number(b.dataset.rating); if (o) return o; }
        if (sort.value === 'highest') { const o = Number(b.dataset.rating) - Number(a.dataset.rating); if (o) return o; }
        return b.dataset.date.localeCompare(a.dataset.date);
      });
      const compactSize = phone.matches ? COLLAPSED_PHONE : COLLAPSED_DESKTOP;
      const collapsed = !expanded && filtered.length > compactSize;
      const size = collapsed ? compactSize : PAGE_SIZE;
      const pages = Math.max(1, Math.ceil(filtered.length / PAGE_SIZE));
      page = Math.min(page, pages);
      const start = collapsed ? 0 : (page - 1) * PAGE_SIZE;
      entries.forEach(r => { r.hidden = true; });
      const shown = filtered.slice(start, start + size);
      shown.forEach(r => { r.hidden = false; list.append(r); });
      const filtering = rating !== 'all' || photosOnly || query;
      const scope = (rating !== 'all' ? ' with ' + rating + (rating === '1' ? ' star' : ' stars') : '') + (photosOnly ? ' with photos' : '') + (query ? ' mentioning “' + search.value.trim() + '”' : '');
      if (!filtered.length) count.textContent = 'No reviews' + scope;
      else if (collapsed) count.textContent = 'Showing ' + shown.length + ' of ' + filtered.length + ' reviews' + scope;
      else count.textContent = (start + 1) + '–' + (start + shown.length) + ' of ' + filtered.length + ' reviews' + scope;
      clear.hidden = !filtering;
      empty.hidden = filtered.length > 0;
      more.hidden = !collapsed;
      more.textContent = 'See all ' + filtered.length + ' reviews';
      pager.hidden = collapsed || pages < 2;
      pageLabel.textContent = 'Page ' + page + ' of ' + pages;
      prev.disabled = page <= 1; next.disabled = page >= pages;
      bars.forEach(b => { const on = b.dataset.xpRfeedBar === rating; b.setAttribute('aria-pressed', String(on)); b.classList.toggle('is-on', on); });
      if (barsBox) barsBox.classList.toggle('is-filtering', rating !== 'all');
      photos.setAttribute('aria-pressed', String(photosOnly));
      requestAnimationFrame(refreshDisclosures);
    }
    const reset = () => { page = 1; update(); };
    sort.addEventListener('change', reset);
    search.addEventListener('input', reset);
    photos.addEventListener('click', () => { photosOnly = !photosOnly; reset(); });
    clear.addEventListener('click', () => { rating = 'all'; photosOnly = false; search.value = ''; reset(); search.focus(); });
    const toTop = () => root.scrollIntoView({ block: 'start', behavior: 'instant' });
    prev.addEventListener('click', () => { page--; update(); toTop(); });
    next.addEventListener('click', () => { page++; update(); toTop(); });
    more.addEventListener('click', () => { expanded = true; update(); });
    phone.addEventListener('change', update);
    let width = 0;
    new ResizeObserver(([o]) => { if (o.contentRect.width !== width) { width = o.contentRect.width; refreshDisclosures(); } }).observe(root);
    if (document.fonts) document.fonts.ready.then(refreshDisclosures);
    controls.hidden = false;
    root.classList.add('is-ready');
    update();
  });
})();
